import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moeda'
})
export class MoedaPipe implements PipeTransform {

  transform(value?: number,  ...args: unknown[]): unknown {
    if(value != null && value > 0)
      return this.fomatar(value);
    return 'R$ 0,00'  
  }

  public fomatar(values: number): string{ 

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
  });
 
  const formattedNumber = formatter.format(values);
    return  formattedNumber; 
 }

}